import { api } from '@/lib/api/client'

export interface StructureNode {
  id: string
  key?: string
  name: string
  lead?: string | null
  projectCount?: number
  headcount?: number
  teams?: StructureNode[]
}

export interface Structure {
  organization: { id: string; name: string }
  divisions: StructureNode[]
}

/**
 * The group as a tree, bounded by the caller's reach — a collaborator sees the
 * divisions their work sits in, and a guest gets 404 rather than learning how
 * AWJ is organised.
 */
export async function fetchStructure(): Promise<Structure> {
  const { data } = await api.get<{ data: Structure }>('/organization/structure')

  return data.data
}
